module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("tool_" + (_vm.tool.toLowerCase())),
    attrs: {
      "id": "app"
    }
  }, [_c('toolbar', {
    class: {
      'disabled-component': _vm.tool === 'Map'
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'nav-on-top': _vm.navigationExpanded
    },
    attrs: {
      "id": "layout-main"
    }
  }, [_c('navigation', {
    class: {
      'disabled-component': _vm.tool === 'Map'
    },
    on: {
      "expanded": function (val) {
        _vm.navigationExpanded = val;
      }
    }
  }), _vm._v(" "), _c('main', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error || _vm.success),
      expression: "error || success"
    }],
    class: {
      error: _vm.error, success: _vm.success
    },
    attrs: {
      "id": "alert-text"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.error || _vm.success))])]), _vm._v(" "), _c('canvas-view'), _vm._v(" "), _c('grid-view')], 1)], 1), _vm._v(" "), _c('ImageUpload'), _vm._v(" "), _c('Textures'), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "texture-options"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1b60834!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 762
// module chunks = 2